import {
  StyledContainer,
  StyledDropdownSkeleton,
  StyledHelperTextSkeleton,
  StyledHelperTextWrapper,
  StyledWrapper,
} from './styled';

const ArtistNameSkeleton = () => (
  <StyledContainer>
    <StyledWrapper>
      <StyledDropdownSkeleton />
      <StyledHelperTextWrapper>
        <StyledHelperTextSkeleton />
        <StyledHelperTextSkeleton />
      </StyledHelperTextWrapper>
    </StyledWrapper>
  </StyledContainer>
);

export default ArtistNameSkeleton;
